import { render, staticRenderFns } from "./PreviewAnswerItem.vue?vue&type=template&id=9c4941e6&scoped=true&"
import script from "./PreviewAnswerItem.vue?vue&type=script&lang=js&"
export * from "./PreviewAnswerItem.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAnswerItem.vue?vue&type=style&index=0&id=9c4941e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4941e6",
  null
  
)

export default component.exports